var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.29228C0 1.02663 1.05202 0 2.34983 0H29.4484C30.7462 0 31.7983 1.02663 31.7983 2.29228V29.7077C31.7983 30.9738 30.7462 32 29.4484 32H2.34983C1.05202 32 0 30.9738 0 29.7077V2.29228Z",
    fill: "#006699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63949 26.7891V12.3393H4.83665V26.7891H9.63949ZM7.23805 10.3664C8.9129 10.3664 9.95535 9.25681 9.95535 7.87016C9.92414 6.45229 8.9129 5.37349 7.26982 5.37349C5.62692 5.37349 4.55273 6.45229 4.55273 7.87016C4.55273 9.25681 5.59497 10.3664 7.20674 10.3664H7.23805Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2969 26.7891H17.0997V18.7197C17.0997 18.2878 17.1309 17.8564 17.2577 17.5477C17.6049 16.6848 18.3952 15.7912 19.722 15.7912C21.4599 15.7912 22.1551 17.1162 22.1551 19.0588V26.7891H26.9575V18.5038C26.9575 14.0654 24.588 12.0002 21.4282 12.0002C18.8372 12.0002 17.6997 13.4484 17.0677 14.4349H17.0998V12.3393H12.297C12.36 13.6951 12.2969 26.7891 12.2969 26.7891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9b183c6ea68a0b6c316d55de97264e10.svg";
export { ForwardRef as ReactComponent };